import { render, staticRenderFns } from "./ArticleViewer.vue?vue&type=template&id=622a6454&"
import script from "./ArticleViewer.vue?vue&type=script&lang=js&"
export * from "./ArticleViewer.vue?vue&type=script&lang=js&"
import style0 from "./ArticleViewer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports